import { render, staticRenderFns } from "./ExpandableSummaryRow.vue?vue&type=template&id=0f81f2db&scoped=true"
import script from "./ExpandableSummaryRow.vue?vue&type=script&lang=js"
export * from "./ExpandableSummaryRow.vue?vue&type=script&lang=js"
import style0 from "./ExpandableSummaryRow.vue?vue&type=style&index=0&id=0f81f2db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81f2db",
  null
  
)

export default component.exports